import React, { useState, useEffect } from 'react';
import { createUseStyles } from 'react-jss';
import { __, withLanguage } from '../functions/commom';
import { useAppState } from '../state/StateContext';
import { Link } from 'react-router-dom';
import Button from './base/Button';
import { TEST_MODE } from '../config';
import { demoState } from '../constants/DemoData';
import Logo from '../assets/images/dai-favicon.png';
import { ReactComponent as LeftIcon } from '../assets/icons/left.svg';

const useStyles = createUseStyles({
  logo: {
    '& img': {
      maxHeight: '40px',
    },
  },
  homeButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    '& svg': {
      width: '24px',
      height: '24px',
      '& path': {
        fill: '#000',
      },
    },
    '&:hover': {
      color: 'var(--dai-primary-color)',
    },
  },
  siteName: {
    fontSize: '18px',
    fontWeight: 'bold',
    borderLeft: '1px solid #ebebeb',
    paddingLeft: '20px',
  },
  topbar: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: '#ffffff',
    padding: '10px 20px',
    borderBottom: '1px solid #ebebeb',
  },
  left: {
    display: 'flex',
    alignItems: 'center',
    gap: '20px',
  },
  right: {
    display: 'flex',
    alignItems: 'center',
    gap: '20px',
  },
  backButton: {
    padding: '8px 16px',
    borderRadius: '20px',
    border: '1px solid #ebebeb',
    backgroundColor: '#fff',
    cursor: 'pointer',
    transition: 'all 0.2s',
    '&:hover': {
      backgroundColor: '#e0e0e0',
    },
  },
});

const Header: React.FC = () => {
  const classes = useStyles();

  const state = useAppState();
  const topBarTitle = __(state.topbar.title.get() || 'Online Application');

  const [showDemoButton, setShowDemoButton] = useState(false);

  useEffect(() => {
    // Check if we should show the demo button
    // Show only on localhost or the specific staging domain
    const hostname = window.location.hostname;

    // Check for localhost
    const isLocalhost = hostname === 'localhost' || hostname === '127.0.0.1';

    // Check for staging site
    const isStaging = hostname === 'dai-app.vmtsd.com';

    // Note: The user mentioned "app.dai.delta-asia.com.mo" is production
    // and "dai.delta-asia.com.mo" is also production (headless mode)
    // so we explicitly exclude those implicitly by only allowing localhost and staging

    if (isLocalhost || isStaging) {
      setShowDemoButton(true);
    } else {
      setShowDemoButton(false);
    }
  }, []);

  return (
    <>
      <div className={classes.topbar}>
        <div className={classes.left}>
          <a
            rel="noreferrer"
            href="https://dai.delta-asia.com.mo/"
            className={classes.homeButton}
          >
            <LeftIcon />
          </a>
          <Link className={classes.logo} to={withLanguage('/')}>
            <img src={Logo} alt="DAI logo" />
          </Link>
          <div className={classes.siteName}>{topBarTitle}</div>
        </div>
        <div className={classes.right}>
          {TEST_MODE && showDemoButton && (
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <Button
                theme="primary"
                onClick={() => state.form.set(demoState?.form)}
              >
                Demo Data
              </Button>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default Header;
